// extracted by mini-css-extract-plugin
export default {"disabled":"NDSSelect_disabled__xYsJ3"};